import { useRepositoryQuery } from '@mews-commander/data-access';

export const useDisplaySourceColumn = () => {
    const { data } = useRepositoryQuery(
        'scimConfiguration',
        'get',
        {},
        { retry: false, meta: { disableDefaultErrorHandler: true } }
    );

    // We only want to hide the column if the SCIM configuration is undefined (we show it if its disabled + enabled)
    return !!data;
};
